import { QueryKeysEnum } from '@/enums';
import { AnalysisBatchSample } from '@/interfaces';
import {
  AnalysisSampleSurveyEntity,
  CreateAnalysisSampleSurvey,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class AnalysisSampleService extends BaseService<
  'analysisSample',
  AnalysisBatchSample,
  CreateAnalysisSampleSurvey
> {
  constructor() {
    super(QueryKeysEnum.ANALYSIS_SAMPLE);
  }

  createSampleSurvey = (payload: {
    analysisSampleId: string;
    surveyLikeData: CreateAnalysisSampleSurvey;
  }): Promise<AnalysisSampleSurveyEntity> => {
    const { analysisSampleId, surveyLikeData } = payload;
    return APIService.post(
      this.path + `/${analysisSampleId}/survey-data`,
      surveyLikeData,
    );
  };

  updatePipelineSettings = (
    payload: Partial<AnalysisBatchSample>,
  ): Promise<AnalysisBatchSample> => {
    const { id, ...rest } = payload;
    return APIService.patch(this.path + '/' + id + '/pipeline-settings', rest);
  };
}
export const analysisSampleService = new AnalysisSampleService();
